import React from 'react';
// import HomeSlider from '../components/sections/HomeSlider';
import HeroSection from '../components/sections/HeroSection';
import SearchSection from '../components/sections/SearchSection';
import ServicesSection from '../components/sections/ServicesSection';
import CoursesSection from '../components/sections/CoursesSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import CurrentAffairsSection from '../components/sections/CurrentAffairsSection';
import FAQSection from '../components/sections/FAQSection'  ;
import ContactSection from '../components/sections/ContactSection';
import { Helmet } from 'react-helmet-async';

const HomePage = () => {
  return (
    <>
    <Helmet>
      <title>BESST - Future of Education</title>
      <meta name="description" content="BESST – India's leading CUET preparation platform. Free mock tests, study materials, PYQs, current affairs, and expert counselling for CUET UG, PG & UGC NET." />
    </Helmet>
      {/* <HomeSlider /> */}
      <HeroSection />
      <SearchSection />
      <ServicesSection />
      <CoursesSection />
      <TestimonialsSection />
      {/* <CurrentAffairsSection /> */}
      <FAQSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
